import { type PropsWithChildren } from 'react';

import { VBaseInput, type VBaseInputProps } from '../VBaseInput';

const VInputTextareaWrapper = ({
  children,
  ...rest
}: PropsWithChildren<VBaseInputProps>) => (
  <VBaseInput {...rest}>{children}</VBaseInput>
);

export default VInputTextareaWrapper;
